/**
 * 项目生产环境配置文件
 */

const config = {
    DEBUG: false,
    API_BASE_URL: '/',
    API: {
        getLiveDetail: '/wap/live/detail',
        getIMToken: '/wap/live/get_token'
    },
    SENTRY: {
        DSN: 'https://2f898da1b503429a889697cce3db8668@sentry.corp.mama.cn/104'
    },
    TIM: {
        APPID: 1400609870,
        LIMIT_MESSAGE_COUNT: 500
    }
};

export default config;
